export const WX_APP_ID = "wx92b601eae5f39b23";
import Cookies from "js-cookie";

export function isIOS() {
  const u = navigator.userAgent;

  // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端

  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

  return isIOS;
}

// 将hex颜色转成rgb
export const hexToRgba = (hex) => {
  const alpha = parseInt(`0x${hex.slice(1, 3)}`, 16) / 255;
  const red = parseInt(`0x${hex.slice(3, 5)}`, 16);
  const green = parseInt(`0x${hex.slice(5, 7)}`, 16);
  const blue = parseInt(`0x${hex.slice(7, 9)}`, 16);
  const rgba = `rgba(${red},${green},${blue},${alpha})`;
  return {
    red,
    green,
    blue,
    alpha,
    rgba,
  };
};

// 字符串转换utf-8
export const EncodeUtf8 = (s1) => {
  var s = escape(s1);
  var sa = s.split("%");
  var retV = "";
  if (sa[0] !== "") {
    retV = sa[0];
  }
  for (var i = 1; i < sa.length; i++) {
    if (sa[i].substring(0, 1) === "u") {
      retV += Hex2Utf8(Str2Hex(sa[i].substring(1, 5)));
      if (sa[i].length >= 6) {
        retV += sa[i].substring(5);
      }
    } else retV += "%" + sa[i];
  }
  return retV;
};

function Str2Hex(s) {
  var c = "";
  var n;
  var ss = "0123456789ABCDEF";
  var digS = "";
  for (var i = 0; i < s.length; i++) {
    c = s.charAt(i);
    n = ss.indexOf(c);
    digS += Dec2Dig(n);
  }

  return digS;
}

function Dec2Dig(n1) {
  var s = "";
  var n2 = 0;
  for (var i = 0; i < 4; i++) {
    n2 = Math.pow(2, 3 - i);
    if (n1 >= n2) {
      s += "1";
      n1 = n1 - n2;
    } else s += "0";
  }
  return s;
}

function Dig2Dec(s) {
  var retV = 0;
  if (s.length === 4) {
    for (var i = 0; i < 4; i++) {
      // eslint-disable-next-line no-eval
      retV += eval(s.charAt(i)) * Math.pow(2, 3 - i);
    }
    return retV;
  }
  return -1;
}

function Hex2Utf8(s) {
  var retS = "";
  var tempS = "";
  var ss = "";
  if (s.length === 16) {
    tempS = "1110" + s.substring(0, 4);
    tempS += "10" + s.substring(4, 10);
    tempS += "10" + s.substring(10, 16);
    var sss = "0123456789ABCDEF";
    for (var i = 0; i < 3; i++) {
      retS += "%";
      ss = tempS.substring(i * 8, (i + 1) * 8);

      retS += sss.charAt(Dig2Dec(ss.substring(0, 4)));
      retS += sss.charAt(Dig2Dec(ss.substring(4, 8)));
    }
    return retS;
  }
  return "";
}

export const isWebview = () => {
  return typeof window !== "undefined" && !!window.piaxiya;
};

export const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    "micromessenger"
  );
};

export const getUrlParam = (name) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const openNativeLink = (schema = '"piaxiya"', host, params = {}) => {
  const query = Object.entries(params)
    .filter(([_, value]) => ![undefined, "undefined", ""].includes(value))
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  if (host === "webview" && !isWebview()) {
    location.href = params.url;
    return;
  }
  console.log(`${schema}://${host}?${query}`);
  location.href = `${schema}://${host}?${query}`;
};

export const jsBridge = (name, ...args) => {
  if (typeof window === "undefined") {
    return;
  }
  if (window.piaxiya) {
    if (args.length) {
      // @ts-ignore
      return window.piaxiya[name]?.(...args);
    } else {
      // @ts-ignore
      return window.piaxiya[name]?.();
    }
  }
};

export const openWebView = (url, barColor = 0, needHeader = 1) => {
  if (!isWebview()) {
    location.href = url;
    return;
  }
  console.log("openWebView ----->", url);
  jsBridge("openWebView", JSON.stringify({ url, barColor, needHeader }));
};

export const getSystemInfo = () => {
  let systemInfo = jsBridge("getSystemInfo") || "{}";

  systemInfo =
    typeof systemInfo === "object" ? systemInfo : JSON.parse(systemInfo);
  return {
    ...systemInfo,
    statusHeight: (systemInfo.statusHeight || 60) / 2,
  };
};

export const wxLoginByCode = (redirectUrl) => {
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APP_ID}&redirect_uri=${encodeURIComponent(
    redirectUrl || origin
  )}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
};

export const getNativeUserInfo = () => {
  const userInfo =
    window.piaxiya?.getUser?.() || Cookies.get("authInfo") || "{}";
  if (typeof userInfo === "object") {
    return userInfo;
  } else {
    return JSON.parse(userInfo);
  }
};

export const joinQuery = (params) => {
  const query = Object.entries(params)
    .filter(([_, value]) => ![undefined, "undefined", ""].includes(value))
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return query ? `?${query}` : "";
};

export default {
  getNativeUserInfo,
  getSystemInfo,
  wxLoginByCode,
  jsBridge,
  openNativeLink,
  isWebview,
  isWechat,
  isIOS,
  EncodeUtf8,
  openWebView,
  joinQuery,
};
